module.exports = __webpack_public_path__ + "img/team-list3.40897ba1.png";